<template>
  <div group-id="bbsctt-list">
    <div class="main-search simple-design-search-box">
      <input style="display:none" type="text" name="faketextremembered" autofocus="true">
      <input style="display:none" type="password" name="fakepasswordremembered">
      <input
        id="search-bbsctt-text"
        v-model="searchText"
        type="search"
        :placeholder="$t('bbs_group.placeholder.search')"
        name="searchText"
        class="simple-design simple-design-search-text"
        @keydown="onKeydownSearch($event)"
      >
      <img class="reading-glasses-on-offline-meeting right clickable" src="/img/offline_meeting/ico_search.png" alt="Search" @click="search($event)">
    </div>
    <div class="nav-tab-container">
      <div class="nav-tab-arrow nav-tab-left-arrow left-scroll-arrow" @click="scrollSiblingUl($event, -100, '#bbs-nav')">
        <i class="fa fa-chevron-left" />
      </div>
      <ul id="bbs-nav" class="nav-tab-item no-display-scrollbar">
        <li v-for="(tabItem, tabItemIndex) in tabItems" :key="'media-channel-index-' + tabItemIndex" :class="{'tab-item': true, 'active': tabItem.id + '' === '' + $route.query.bbsId}" @click="openBbs($event, tabItem.id)">
          <span class="slide-card-title">{{ tabItem.title }}</span>
        </li>
      </ul>
      <div class="nav-tab-arrow nav-tab-right-arrow right-scroll-arrow" @click="scrollSiblingUl($event, 100, '#bbs-nav')">
        <i class="fa fa-chevron-right" />
      </div>
    </div>
    <bbs :key="$route.query.bbsId" :is-group="true" />
  </div>
</template>

<script>
import bbs from './Bbs.vue'
export default {
  components: {
    bbs
  },
  data() {
    return {
      searchText: '',
      tabItems: []
    }
  },
  mounted() {
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText
    }
    this.loadBbsList()
  },
  methods: {
    loadBbsList() {
      const url = '/bbs/public/bbsList'
      this.$axios.$get(url).then(response => {
        if (response.resultCode === 'success') {
          if (response.data) {
            this.tabItems = response.data
            const selectedBbsId = this.$route.query.bbsId
              ? this.$route.query.bbsId
              : this.tabItems[0].id
            if (!this.$route.query.mode || !this.$route.query.bbsId) {
              this.openBbs(undefined, selectedBbsId)
            }
          } else {
            this.tabItems = []
          }
          this.$eventHub.$emit('content-loaded')
          this.$forceUpdate()
        }
      })
    },
    onKeydownSearch(e) {
      if (e.keyCode === 13) {
        if (e) {
          e.stopPropagation()
          e.preventDefault()
        }
        this.search(e)
      }
    },
    openBbs(e, bbsId) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      this.vibrate(e)
      this.searchText = ''
      const query = {}
      for (const key in this.$route.query) {
        if (key !== 'bbsId' && key !== 'searchText') {
          query[key] = this.$route.query[key]
        }
      }
      query.mode = 'list'
      query.bbsId = bbsId
      this.$router.push({
        path: this.$router.currentRoute.path,
        query: query
      })
    },
    search(e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      const query = {}
      for (const key in this.$route.query) {
        if (key !== 'searchText') {
          query[key] = this.$route.query[key]
        }
      }
      query.mode = 'list'
      query.searchText = this.searchText
      this.vibrate(e)
      this.$router.push({
        path: this.$router.currentRoute.path,
        query: query
      })
      this.searchItems(
        e,
        '#search-bbsctt-text',
        parseInt(
          $(this.$el)
            .find('[theme-bbs][component-id]')
            .attr('component-id')
        )
      )
    }
  }
}
</script>

<style scoped>
.nav-tab-container {
  display: flex;
}
.nav-tab-container .nav-tab-arrow {
  width: 1.5rem;
  padding: 1rem 0.3rem;
  color: #999999;
}
.nav-tab-container .nav-tab-left-arrow {
  text-align: left;
}
.nav-tab-container .nav-tab-right-arrow {
  text-align: right;
}
.nav-tab-container .nav-tab-item {
  width: calc(100% - 3rem);
}
.nav-tab-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  overflow-x: auto;
  margin-bottom: 0;
}
.nav-tab-item li {
  padding: 1rem 2rem;
  margin: 0 1rem;
  font-size: 0.916rem;
  font-weight: bold;
  border-bottom: 3px solid transparent;
}
.nav-tab-item li.active {
  border-bottom: 3px solid #360ea6;
}
>>> .has-no-data {
  text-align: center;
  padding: 5rem 0 !important;
}
</style>
